import { isValid as isValidCpf } from '@fnando/cpf';
import { isValid as isValidCnpj } from '@fnando/cnpj';
import { isMatch } from 'date-fns';

export const isValidCNPJ = (value: string) => isValidCnpj(value);
export const isValidCPF = (value: string) => isValidCpf(value);

export function isValidFullName(value: string) {
  return value.trim().split(' ').length > 1;
}

export function isValidDate(value: string, args: string[]) {
  const [dateFormat] = args;

  if (!dateFormat || value.length !== dateFormat.length) return false;

  return isMatch(value, dateFormat);
}
